const config = {
  api: "https://commerceapi.io",
  oauth: "https://account.logicbroker.com",
  logos: "https://logicbrokeradx.blob.core.windows.net/logos/",
  clientid: "dev_portal",
  production: true,
  googleAnalytics: 'UA-42285878-2',
  thoughtSpot: {
    host: 'https://virtualstock.thoughtspot.cloud',
    liveboardId: '62596cda-7b28-4d68-a6de-45eaed5827df',
    // LB-505: 'auto_mode' = Spotter Auto mode -- picks the relevant data model per
    // query across all models, instead of pinning to one worksheet.
    worksheetId: 'auto_mode'
  }
};
export default config;
